import clsx from 'clsx';
import React, { createContext } from 'react';

import { DialogsContainer } from '@/components/Dialogs';
import { Drawer } from '@/components/Elements/Drawer';
import { SideNavigationMenu, TopBar } from '@/components/Layout';
import { menuConfig } from '@/config/menuConfig';
import { SIDE_NAVIGATION_MENU } from '@/globalConsts';
import { useDisclosure } from '@/hooks/useDisclosure';
import { isFeatureEnabled } from '@/utils';

export interface MainLayoutProps {
	children: React.ReactNode;
}

type DrawerContextType = {
	isOpen: boolean;
};

export const DrawerContext = createContext<DrawerContextType>({} as DrawerContextType);

export const MainLayout = (props: MainLayoutProps) => {
	const { children } = props;
	const { close, isOpen, open } = useDisclosure();
	const contextValue = { isOpen };

	return (
		<DrawerContext.Provider value={contextValue}>
			<main
				className={clsx(
					'pt-20 outer min-w-[100vw]',
					isOpen
						? `${SIDE_NAVIGATION_MENU.PADDING_LEFT.EXPANDED} transition-width delay-100 duration-300 ease-in-out`
						: `${SIDE_NAVIGATION_MENU.PADDING_LEFT.DEFAULT} transition-width delay-100 duration-300 ease-in-out`
				)}
			>
				<TopBar isCollapsed={isOpen} />
				{isFeatureEnabled('PATIENT_ENGAGEMENT_FLOW') ? (
					<SideNavigationMenu isOpen={isOpen} close={close} open={open} />
				) : (
					<Drawer
						config={menuConfig}
						close={close}
						isOpen={isOpen}
						open={open}
						className='fixed top-0 left-0'
					/>
				)}
				{children}
				<DialogsContainer />
			</main>
		</DrawerContext.Provider>
	);
};
